import { Bar } from 'react-chartjs-2';
import type { TimeseriesPoint } from '../../types';

export default function CallVolumeChart({ data }: { data: TimeseriesPoint[] }) {
  if (!data || data.length === 0) {
    return <p style={{ color: '#8a95a5', fontSize: 13 }}>No data</p>;
  }
  return (
    <Bar
      data={{
        labels: data.map((d) => d.date),
        datasets: [
          { label: 'Answered', data: data.map((d) => Number(d.answered) || 0), backgroundColor: '#2a5a8c', borderRadius: 4 },
          { label: 'Missed', data: data.map((d) => Number(d.missed) || 0), backgroundColor: '#dc2626', borderRadius: 4 },
          { label: 'IVR Only', data: data.map((d) => Number(d.ivr) || 0), backgroundColor: '#fdba74', borderRadius: 4 },
        ],
      }}
      options={{
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'bottom',
            labels: { usePointStyle: true, pointStyle: 'circle', font: { size: 11 } },
          },
        },
        scales: {
          x: { stacked: true, grid: { display: false }, ticks: { font: { size: 10 } } },
          y: { stacked: true, beginAtZero: true, ticks: { font: { size: 10 } } },
        },
      }}
    />
  );
}
